import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getDocumentTitle } from '../utils/routeTitle';

/** Keeps the browser tab title in step with the current route. Renders nothing. */
export default function RouteTitle({ signedIn }) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getDocumentTitle(pathname, { signedIn });
  }, [pathname, signedIn]);

  return null;
}
